var ThemeColor;
(function (ThemeColor) {
    ThemeColor["AQUA"] = "aqua";
    ThemeColor["BLUE"] = "blue";
    ThemeColor["GREEN"] = "green";
    ThemeColor["GREY"] = "grey";
    ThemeColor["GROUP_BLUE"] = "group-blue";
    ThemeColor["ORANGE"] = "orange";
    ThemeColor["PINK"] = "pink";
    ThemeColor["PURPLE"] = "purple";
})(ThemeColor || (ThemeColor = {}));
export default ThemeColor;
//# sourceMappingURL=theme-color.js.map